import { Badge } from "@/components/ui/badge";
import {
  useGetCustomVerificationsCountQuery,
  useGetCustomVerificationTypesQuery,
} from "@/data/queries";

export const CustomVerificationsList = ({ tagUid }: { tagUid: string }) => {
  const { data: customTypes } = useGetCustomVerificationTypesQuery();

  const { data: customVerificationCounts } =
    useGetCustomVerificationsCountQuery(tagUid);

  return (
    <div className="flex flex-col gap-1">
      {customTypes?.map((type) => {
        const count = customVerificationCounts?.[type.id] || 0;

        return (
          <Badge variant={count > 0 ? "green" : "secondary"} key={type.id}>
            {type.name}: {count}
          </Badge>
        );
      })}
    </div>
  );
};
